<template>
    <div class="container">
        <b-modal
            :model-value="modalCrear"
            :no-close-on-backdrop="true"
            hide-footer
            hide-header-close
            centered
            :title="labels.title"
            header-class="reset-modal-header"
            title-class="reset-modal-title"
            body-class="reset-modal-body"
            class="reset-password-dialog"
        >
            <div class="uniform-modal-body">
                <div class="password-policy-box mb-3">
                    <div class="password-policy-title">
                        {{ labels.formInfoTitle }}
                    </div>
                    <div class="password-policy-item">
                        {{ labels.formInfoSubtitle }}
                    </div>
                </div>
                <b-col md="4" lg="12" class="p-0 mx-auto">
                    <b-form-group>
                        <label>{{ labels.codigo }}</label>
                        <b-form-input
                            v-model="form.codigo"
                            type="number"
                            class="reset-input"
                        ></b-form-input>
                        <label>{{ labels.descripcion }}</label>
                        <b-form-input
                            v-model="form.descripcion"
                            type="text"
                            class="reset-input"
                        ></b-form-input>
                        <label>{{ labels.frecuencia }}</label>
                        <b-form-input
                            v-model="form.frecuencia"
                            type="number"
                            class="reset-input"
                        ></b-form-input>
                        <label>{{ labels.modalidad }}</label>
                        <b-form-select v-model="form.modalidad" class="reset-input" autocomplete="off">
                            <option value="">{{ labels.select }}</option> 
                            <option value="A">{{ labels.anticipada }}</option> 
                            <option value="F">{{ labels.fija }}</option> 
                            <option value="V">{{ labels.vencida }}</option> 
                        </b-form-select>
                    </b-form-group>
                    <div class="reset-dialog-actions d-flex justify-content-end mt-3 uniform-actions-wrap">
                        <b-button
                            class="mr-2 reset-btn-secondary"
                            @click="cierraModal()"
                        >
                            {{ labels.close }}
                        </b-button>
                        <b-button
                            class="reset-btn-primary"
                            @click="guardarTipoTasa()"
                        >
                            {{ labels.save }}
                        </b-button>
                    </div>
                </b-col>
            </div>
        </b-modal>
    </div>
</template>

<script>

import TipoTasa from '../../../services/TipoTasas'; 

export default {
    name: 'Crear',
    props:{
        modalCrear: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            form: {
                codigo: "",
                descripcion: "",
                frecuencia: "",
                modalidad: ""
            }
        }
    },
    computed:{
        labels(){
            if(this.$store.state._language == "es-ES"){ 
                return {
                    title : 'Crear tipo tasa',
                    save : 'Guardar',
                    close : 'Cerrar',
                    codigo : 'Código',
                    descripcion : 'Descripción',
                    frecuencia : 'Frecuencia',
                    modalidad : 'Modalidad',
                    select : 'Seleccione...', 
                    anticipada : 'Anticipada',
                    fija : 'Fija',
                    vencida : 'Vencida',
                    formInfoTitle: "Datos del tipo de tasa",
                    formInfoSubtitle: "Completa la información y guarda el nuevo tipo de tasa."
                }
            }else{
                return {
                    title : 'Create Rate',
                    save : 'Save',
                    close : 'Close',
                    codigo : 'Code',
                    descripcion : 'Description',
                    frecuencia : 'Frecuency',
                    modalidad : 'Type',
                    select : 'Select...', 
                    anticipada : 'Anticipated',
                    fija : 'Fixed',
                    vencida : 'Expire',
                    formInfoTitle: "Rate type data",
                    formInfoSubtitle: "Complete the information and save the new third type."
                }
            }
        }
    },
    methods:{
        cierraModal(){
            this.cleanInp();
            this.$emit('cierraModal',false) 
        },
        guardarTipoTasa(){
            if (
                !this.form.codigo ||
                !this.form.descripcion.trim() ||
                !this.form.frecuencia ||
                !this.form.modalidad
            ) {
                this.$toast.error("Campo(s) pendiente(s) por diligenciar");
                return;
            }

            const info = {
                codigo: this.form.codigo,
                descripcion: this.form.descripcion,
                frecuencia: this.form.frecuencia,
                modalidad: this.form.modalidad,
                idUser: this.$store.state.userId
            };
            // console.log(info);

            TipoTasa.createTipoTasa(info) 
            .then((res) => { 

                if(res.status == 201){ 
                    this.$toast.success(res.data.message) 
                    this.$emit("creado");
                    this.cierraModal();
                
                }else if(res.status == 204){ 
                    this.$toast.error('Tipo tasa ingresada ya existe.') 
                }
            })
            .catch((err) => {
                console.error(err);
                this.$toast.error("Ocurrió un error al crear el tipo de tasa.");
            });
        },
        cleanInp(){
            this.form.codigo = "";
            this.form.descripcion = "";
            this.form.frecuencia = ""
            this.form.modalidad = ""
        }
    }
}
</script>

<style>

</style>
